import { useCallback } from "react";
import { SERVER_HOST } from "../../constants/config";
import { getEkycHeaders } from "../../utils/ekycHeaders";

const BaseAPIUrl = SERVER_HOST;

const usePassportService = () => {

  // Resolves to the response body plus `httpStatus`, so a failed upload can be
  // logged with its HTTP status (#244). A body that is not JSON still rejects,
  // now with `httpStatus` on the error.
  const upload = useCallback(
    async (params) => {
      const config = {
        method: "post",
        headers: getEkycHeaders(),
        body: params,
      };

      const response = await fetch(
        BaseAPIUrl + "/ekyc/passport-verification/upload",
        config
      );

      let body;
      try {
        body = await response.json();
      } catch (error) {
        error.httpStatus = response.status;
        throw error;
      }
      return { ...body, httpStatus: response.status };
    },
    []
  );

  const verify = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders({ "Content-Type": "application/json" }),
        method: "post",
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/passport-verification/verify",
        config
      ).then((response) => response.json());
    },
    []
  );

  const checkResult = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders({ "Content-Type": "application/json" }),
        method: "post",
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/passport-verification/check-result",
        config
      ).then((response) => response.json());
    },
    []
  );

  const getPassportRejectReason = useCallback(
    async (params) => {
      const config = {
        headers: getEkycHeaders({ "Content-Type": "application/json" }),
        method: "post",
        body: JSON.stringify(params),
      };

      return fetch(
        BaseAPIUrl + "/ekyc/passport-verification/reject-reason",
        config
      ).then((response) => response.json());
    },
    []
  );

  return {
    upload,
    verify,
    checkResult,
    getPassportRejectReason,
  };
};

export { usePassportService };
